import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Switch, Route } from 'react-router-dom';
import 'react-dates/initialize';

import favicon from './assets/favicon.svg';
import faviconPng from './assets/favicon.png';
import appleTouchIcon from './assets/apple-touch-icon.png';
import Gateway from './pages/Gateway';
import OAuthCallback from './pages/OAuthCallback';
import StudioPage from './pages/StudioPage';
import { APP_NAME } from '../utils/constants';
import { SidebarProvider } from './components/layout/app-sidebar/sidebar-store';
import { SidePanelProvider } from './components/layout/side-panel/side-panel-store';

import 'react-dates/lib/css/_datepicker.css';
import { studioEventDefaults } from '../utils/analytics-page';
import './assets/_datepicker.css';
import './assets/brand.css';
import './assets/main.scss';
import './components/layout/app-sidebar/sidebar.css';
import './components/topbar/topbar-user.css';

if (__BROWSER__) {
  require('../scripts/analytics');
  window.analytics.addSourceMiddleware(
    studioEventDefaults(() => window.location.pathname)
  );
}

const App = () => (
  <SidebarProvider>
    <SidePanelProvider>
      <Helmet
        defaultTitle={APP_NAME}
        link={[
          { rel: 'icon', type: 'image/svg+xml', href: favicon },
          { rel: 'icon', type: 'image/png', href: faviconPng },
          { rel: 'apple-touch-icon', href: appleTouchIcon },
        ]}
        meta={[{ name: 'theme-color', content: '#071834' }]}
      />

      <Switch>
        <Route path="/oauth/callback">
          <OAuthCallback />
        </Route>
        <Route path="/tenant/:tenant">
          <StudioPage />
        </Route>
        <Route path="/">
          <Gateway />
        </Route>
      </Switch>
    </SidePanelProvider>
  </SidebarProvider>
);

export default App;
